export interface IExceptionalService {
    isErrorState(): boolean;
    handleErrorResponse(response): void;
}

export class ExceptionalService implements IExceptionalService {

    private _errorStates: string[] = ['unexpected', 'unavailable', 'changePchs', 'unauthorized'];
    static $inject: string[] = ['$state'];

    constructor(private _$state: ng.ui.IStateService) {
    }

    isErrorState(): boolean {
        return _.some(this._errorStates, f => this._$state.is(f));
    }

    handleErrorResponse(response) {
        if (this._$state.is('login'))
            return;

        if (response.status === -1) {
            this._$state.go('unexpected', { link: 'logout' }, {
                location: 'replace'
            });
        } else if (response.status === 404 || response.status === 422) {
            this._$state.go('unavailable', {}, {
                location: 'replace'
            });
        } else if (response.status === 403) {
            this._$state.go('unauthorized', {}, {
                location: 'replace'
            });
        }
        else {
            this._$state.go('unexpected', {}, {
                location: 'replace'
            });
        }
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/exceptionalService.ts
 **/